const viMessages = {
  /* 01.General */
    "main.name": "Tên",
  "main.sentiment": "Cảm xúc",
  "main.urgency": "Mức độ khẩn cấp",
  "main.language": "Ngôn ngữ",
  "main.agent": "Nhân viên",
  "main.property_name": "Tên cơ sở",
  "main.booking_number": "Số đặt chỗ",
  "main.check_out": "Trả phòng",
  "main.check_in": "Nhận phòng",
  "main.adults": "Người lớn",
  "main.corporate_code": "Mã doanh nghiệp",
  "main.group_code": "Mã nhóm",
  "main.promo_code": "Mã khuyến mãi",
  "main.ai_response": "Phản hồi AI",
  "main.template_response": "Phản hồi mẫu",
  "main.converttoticket": "Chuyển thành phiếu",
  "main.switch_property": "Chuyển cơ sở",
  "main.Group_id": "ID nhóm",
  "main.integration_id": "ID tích hợp",
  "main.submit": "Gửi",
  "main.cancel": "Hủy",
    "main.select_template": "Chọn mẫu",
  "main.rooms": "Phòng",
  "main.rates": "Giá",

  //footer
   "footer.knowledge": "Kiến thức",
  "footer.home": "Trang chủ",
  "footer.help": "Trợ giúp",

  //ticket

  "ticket.thank_you": "Cảm ơn bạn đã gửi biểu mẫu",
  "ticket.ticket": "Phiếu yêu cầu",
  "ticket.details": "Vui lòng điền biểu mẫu mô tả chi tiết phiếu yêu cầu.",
  "ticket.select_category": "Chọn danh mục",
  "ticket.category": "Danh mục",
  "ticket.title": "Tiêu đề",
  "ticket.notes": "Ghi chú",
  "ticket.status": "Trạng thái",
  "ticket.assigned_to": "Được giao cho",
  "ticket.submit_form": "Gửi biểu mẫu",

  
  "main.total": "Tổng cộng",
  "main.pastetooutlook": "Dán vào Outlook",
  "main.children": "Trẻ em",
  "main.promocode": "Mã khuyến mãi/doanh nghiệp/nhóm",
  "main.exact_match_only": "Chỉ khớp chính xác",
  "main.search": "Tìm kiếm",
  "main.no_rate_match": "Không có mức giá nào phù hợp với lựa chọn của bạn. Vui lòng điều chỉnh tìm kiếm và thử lại.",
  "main.translate_to": "Dịch sang",
  "main.regenerate": "Tạo lại",
  "main.copy_text": "Sao chép văn bản",
  "main.additional_instructions": "Hướng dẫn bổ sung",

  "faq.helpcenter": "Trung tâm trợ giúp",
  "faq.reply.email.sabre.question": "Làm cách nào để trả lời email bằng Aven Hospitality Concierge Email Automation?",
  "faq.reply.email.sabre.answer": "Mở email và khởi chạy tiện ích Aven Hospitality. Bạn có thể chọn một trong ba tùy chọn: sử dụng mẫu có sẵn, tạo phản hồi AI hoặc chuyển email thành phiếu yêu cầu. Chọn tùy chọn phù hợp, xem lại phản hồi, chỉnh sửa nếu cần và gửi trực tiếp từ Outlook.",

  "faq.rates.availability.question": "Làm cách nào để thêm giá, tình trạng phòng và thông tin phòng vào phản hồi?",
  "faq.rates.availability.answer": "Sử dụng tính năng + Rates để nhập thông tin khách như ngày và số lượng khách. Concierge sẽ thêm tình trạng phòng và giá chính xác vào phản hồi.",

  "faq.different.language.question": "Tôi nên làm gì nếu email bằng ngôn ngữ khác?",
  "faq.different.language.answer": "Aven Hospitality Concierge cho phép bạn dịch email đến sang ngôn ngữ mong muốn.",

  "faq.pin.addin.question": "Làm cách nào để đảm bảo tiện ích luôn có sẵn trong Outlook?",
  "faq.pin.addin.answer": "Ghim tiện ích Aven Hospitality Concierge trong Outlook để luôn hiển thị.",

  "faq.knowledge.hub.question": "Tùy chọn tìm kiếm Knowledge Hub là gì?",
  "faq.knowledge.hub.answer": "Tìm kiếm Knowledge Hub giúp bạn nhanh chóng tìm thông tin cụ thể của cơ sở trong Outlook.",

  "faq.reply.email.myma.question": "Làm cách nào để trả lời email bằng Myma?",
  "faq.reply.email.myma.answer": "Mở email và khởi chạy tiện ích Myma. Bạn có thể sử dụng mẫu, tạo phản hồi AI hoặc chuyển email thành phiếu yêu cầu.",

  "faq.room.details.question": "Làm cách nào để thêm thông tin phòng vào phản hồi?",
  "faq.room.details.answer": "Sử dụng + Rooms để thêm mô tả phòng và hình ảnh.",

  "faq.myma.different.language.question": "Tôi nên làm gì nếu email bằng ngôn ngữ khác?",
  "faq.myma.different.language.answer": "Myma cho phép bạn dịch email đến sang ngôn ngữ mong muốn.",

  "faq.myma.pin.addin.question": "Làm cách nào để đảm bảo tiện ích luôn có sẵn trong Outlook?",
  "faq.myma.pin.addin.answer": "Ghim tiện ích Myma trong Outlook để tự động mở cùng mỗi email.",

};
export default viMessages;